// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-string-field';

export const Component = () => <path d='M19 8.737h-4.667V19h-2.666V8.737H7V6h12v2.737Z' />;

export const viewBox = '0 0 25 25';
